import { z } from "zod";

import { IdManagementCategory } from "@/constants/idManagement";
import { OrderDirection } from "@/constants/orderDirection";

import { ProxyUserTableColumns } from "./-table/type";

export const ProxyUserTableFilterSchema = z.object({
  sortOrder: z
    .nativeEnum(OrderDirection)
    .default(OrderDirection.ASC)
    .optional(),
  sortColumn: z
    .enum([ProxyUserTableColumns.LOGIN_ID, ProxyUserTableColumns.PERSON])
    .optional(),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),

  category: z
    .nativeEnum(IdManagementCategory)
    .default(IdManagementCategory.ALL),

  freeText: z.string().optional(),
  haveAppIdIn: z.array(z.string()).optional(),
});
